import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

import { committeeMembershipOptions } from './model/CommitteeMembershipModel';

type CommitteeMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function CommitteeMembershipSelectControl<T extends FieldValues>(
  props: CommitteeMembershipSelectControlProps<T>,
) {
  const { data, isLoading, isError } = useQuery(committeeMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
